import { useEffect } from 'react';

const ApiTimingPanel = () => {
  useEffect(() => {
    const handleTiming = (e) => {
      const { label, duration, ok, cached, cacheStatus, ts } = e.detail || {};
      const status = cacheStatus ?? (cached ? 'HIT' : 'MISS/none');
      // Log API timing information to the browser console instead of a UI panel
      console.log('[API TIMING]', { label, duration, ok, cached, cacheStatus: status, ts });
    };

    window.addEventListener('api-timing', handleTiming);
    return () => window.removeEventListener('api-timing', handleTiming);
  }, []);

  // No UI – this component only listens and logs to console
  return null;
};

export default ApiTimingPanel;
